import { defineMessages } from "react-intl";

export const messages = defineMessages( {
	currentSubscription: {
		id: "paidProratedUpgradeTool.currentSubscription",
		defaultMessage: "Current subscription",
	},
	upgradeTo: {
		id: "paidProratedUpgradeTool.upgradeTo",
		defaultMessage: "Upgrade to",
	},
	whatIsIncluded: {
		id: "paidProratedUpgradeTool.whatIsIncluded",
		defaultMessage: "What's included",
	},
	proratedUpgradePrice: {
		id: "paidProratedUpgradeTool.proratedUpgradePrice",
		defaultMessage: "Price to pay now",
	},
	proratedUpgradePriceDescription: {
		id: "paidProratedUpgradeTool.proratedUpgradePriceDescription",
		defaultMessage: "You'll pay a prorated amount now to upgrade immediately." +
			" This price is based on the remaining time of your current subscription" +
			" and the difference in price between the two products.",
	},
	nextRenewalPrice: {
		id: "paidProratedUpgradeTool.nextRenewalPrice",
		defaultMessage: "Future renewal price",
	},
	nextRenewalPriceDescription: {
		id: "paidProratedUpgradeTool.nextRenewalPriceDescription",
		defaultMessage: "Your billing date stays the same. This is what you'll pay on your next renewal.",
	},
	nextBillingSubtext: {
		id: "paidProratedUpgradeTool.nextBillingSubtext",
		defaultMessage: "/ {term} (ex. VAT and possible discounts)",
	},
	incVat: {
		id: "paidProratedUpgradeTool.incVat",
		defaultMessage: "(inc. VAT)",
	},
	refundPolicyLabel: {
		id: "paidProratedUpgradeTool.refundPolicyLabel",
		defaultMessage: "I agree to the {link}",
	},
	screenReaderRefundPolicyLabel: {
		id: "paidProratedUpgradeTool.screenReaderRefundPolicyLabel",
		defaultMessage: "I agree to the refund policy for upgrades.",
	},
	refundPolicyLabelLink: {
		id: "paidProratedUpgradeTool.refundPolicyLabelLink",
		defaultMessage: "refund policy for upgrades.",
	},
	termsPolicyLabel: {
		id: "paidProratedUpgradeTool.termsPolicyLabel",
		defaultMessage: "I've read and accept the {link}",
	},
	screenReaderTermsPolicyLabel: {
		id: "paidProratedUpgradeTool.screenReaderTermsPolicyLabel",
		defaultMessage: "I've read and accept the terms of service.",
	},
	termsPolicyLabelLink: {
		id: "paidProratedUpgradeTool.termsPolicyLabelLink",
		defaultMessage: "terms of service.",
	},
	cancel: {
		id: "paidProratedUpgradeTool.cancel",
		defaultMessage: "Cancel",
	},
	close: {
		id: "paidProratedUpgradeTool.close",
		defaultMessage: "Close",
	},
	proceedToCheckout: {
		id: "paidProratedUpgradeTool.proceedToCheckout",
		defaultMessage: "Proceed to checkout",
	},
	errorOccurredWhileFetching: {
		id: "paidProratedUpgradeTool.errorOccurredWhileFetching",
		defaultMessage: "Oops! Something went wrong while preparing your upgrade options.",
	},
	noValidUpgrades: {
		id: "paidProratedUpgradeTool.noValidUpgrades",
		defaultMessage: "There is no upgrade available for your subscription at this time. Please check again later!",
	},
	tryAgain: {
		id: "paidProratedUpgradeTool.tryAgain",
		defaultMessage: "Try again",
	},
	errorLoadingPrice: {
		id: "paidProratedUpgradeTool.errorLoadingPrice",
		defaultMessage: "Could not load the upgrade price. Please try refreshing the page.",
	},
	calculatingPrice: {
		id: "paidProratedUpgradeTool.calculatingPrice",
		defaultMessage: "Calculating upgrade price...",
	},
	upgradeError: {
		id: "paidProratedUpgradeTool.upgradeError",
		defaultMessage: "Something went wrong preparing your upgrade. Please try again or contact support.",
	},
	popupBlockedError: {
		id: "paidProratedUpgradeTool.popupBlockedError",
		defaultMessage: "Unable to open checkout. Please disable your popup blocker and try again, or",
	},
	clickHereToCheckout: {
		id: "paidProratedUpgradeTool.clickHereToCheckout",
		defaultMessage: "click here to open checkout manually.",
	},
	modalHeader: {
		id: "paidProratedUpgradeTool.modalHeader",
		defaultMessage: "Upgrade your subscription",
	},
} );
